import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  headerWrapper: theme => css`
    display: flex;
    align-items: center;
    width: 100%;
    min-height: 72px;
    padding: 0 ${theme.spacing.xs};
    box-sizing: border-box;
  `,

  headerContent: theme => css`
    width: 100%;
    border-style: solid;
    border-bottom-color: ${theme.colors.neutral[100]};
    border-bottom-width: 1px;
  `,

  logoWhitelabel: theme => css`
    max-width: 120px;
    padding: ${theme.spacing.xxs} 0;
  `,

  logoConexa: theme => css`
    padding: ${theme.spacing.xs} 0;
  `,

  contentWrapper: theme => css`
    width: 100%;
    max-width: 415px;
    margin-bottom: ${theme.spacing.xl};
    padding: ${theme.spacing.xs};
    box-sizing: border-box;

    @media (max-width: ${theme.grid.breakpoint.sm}) {
      margin-top: ${theme.spacing.lg};
    }
  `,

  backLink: theme => css`
    display: flex;
    border: 0;
    margin-bottom: ${theme.spacing.sm};
    padding-left: 0;
    padding-right: 0;
  `,

  validationText: theme => css`
    margin-top: ${theme.spacing.xxs};
    margin-bottom: ${theme.spacing.lg};
  `,

  codeInputWrapper: theme => css`
    display: flex;
    justify-content: center;
    input {
      font-size: ${theme.fontSizes.lg};
      width: fit-content;
      width: 100%;
      height: 48px;
      padding: 0 ${theme.spacing.xs};

      &:disabled {
        border-color: ${theme.colors.neutral[100]};
        background-color: transparent;
      }

      &[data-valid='true'] {
        pointer-events: none;
      }
    }
  `,

  validationTimeText: theme => css`
    margin: ${theme.spacing.md} 0 ${theme.spacing.sm} 0;
  `,

  validationCodeText: theme => css`
    margin-bottom: ${theme.spacing.sm};
    font-size: ${theme.fontSizes.sm};
    span {
      color: ${theme.colors.brand.primary[300]};
      font-size: ${theme.fontSizes.sm};
    }
  `,

  errorText: theme => css`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: ${theme.fontSizes.sm};
    gap: ${theme.spacing.xxs};
    margin: ${theme.spacing.lg} 0 ${theme.spacing.sm} 0;
    color: ${theme.colors.feedback.error[300]};

    svg {
      fill: ${theme.colors.feedback.error[300]};
    }
  `,

  successText: theme => css`
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: ${theme.fontSizes.sm};
    gap: ${theme.spacing.xxs};
    margin: ${theme.spacing.lg} 0 ${theme.spacing.sm} 0;
    color: ${theme.colors.feedback.success[300]};

    svg {
      fill: ${theme.colors.feedback.success[300]};
    }
  `,

  loaderWrapper: theme => css`
    display: flex;
    justify-content: center;
    margin-top: ${theme.spacing.lg};

    svg {
      path {
        :nth-child(2) {
          fill: ${theme.colors.brand.primary[300]};
        }
      }
    }
  `,

  supportLink: theme => css`
    margin-bottom: ${theme.spacing.xxs};
  `,
})

export { useStyles }
